var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsIncludedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.7497 16.0482L16.4217 21.1154H13.1963C12.9045 21.1154 12.666 21.3507 12.666 21.6456V25.348C12.666 25.6398 12.9013 25.8782 13.1963 25.8782H14.674C14.5642 27.3811 15.427 28.8338 16.8672 29.43C17.3096 29.6151 19.3522 30.1422 21.0151 28.3726L25.7529 30.9454C26.349 31.165 26.5373 30.663 26.5373 30.481V16.5125C26.5341 16.3274 26.3584 15.8474 25.7497 16.0482ZM13.7265 24.8209V22.1727H16.0296V24.8209H13.7265ZM17.2751 28.4542C16.2398 28.0275 15.6279 26.9638 15.7409 25.8814H16.428L20.0645 27.858C19.3585 28.5985 18.2509 28.8589 17.2751 28.4542ZM17.0869 25.0374V21.9625L25.4768 17.4005V29.5899L17.0869 25.0374Z",
    fill: "#8D90A5",
    stroke: "#8D90A5",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9729 19.1134C29.769 18.9032 29.4364 18.8907 29.223 19.0946L27.6354 20.61C27.4252 20.814 27.4032 21.1623 27.6166 21.3599C27.8739 21.589 28.2661 21.4729 28.3665 21.3725L29.9541 19.8633C30.1643 19.6594 30.1769 19.3268 29.9729 19.1134Z",
    fill: "#8D90A5",
    stroke: "#8D90A5",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.1937 22.9666H29.0068C28.715 22.9666 28.4766 23.2018 28.4766 23.4968C28.4766 23.7886 28.7119 24.027 29.0068 24.027H31.1937C31.4855 24.027 31.724 23.7917 31.724 23.4968C31.724 23.2018 31.4855 22.9666 31.1937 22.9666Z",
    fill: "#8D90A5",
    stroke: "#8D90A5",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.9574 27.1335L28.3698 25.6243C28.1596 25.4204 27.8207 25.4298 27.6199 25.6431C27.416 25.8533 27.4254 26.1922 27.6387 26.393L29.2263 27.9022C29.3268 27.9995 29.7409 28.1187 29.9763 27.8834C30.1834 27.6762 30.1708 27.3343 29.9574 27.1335Z",
    fill: "#8D90A5",
    stroke: "#8D90A5",
    strokeWidth: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 43313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.8889 29H1C1 23.5143 5.05644 18.9762 10.3333 18.2214M18.1111 7.22222C18.1111 10.6587 15.3253 13.4444 11.8889 13.4444C8.45245 13.4444 5.66667 10.6587 5.66667 7.22222C5.66667 3.78578 8.45245 1 11.8889 1C15.3253 1 18.1111 3.78578 18.1111 7.22222Z",
    stroke: "#8D90A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsIncludedIcon);
export default __webpack_public_path__ + "static/media/campaignsIncludedIcon.03ae079720cad1d65c3a763117dcb2c2.svg";
export { ForwardRef as ReactComponent };